import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selections: Object }

  connect() {
    Object.entries(this.selectionsValue).forEach(([fieldKey, selection]) => {
      const field = document.querySelector(
        `[data-autocomplete-field-key-value="${CSS.escape(fieldKey)}"]`
      )

      field?.dispatchEvent(new CustomEvent("autocomplete:select", {
        detail: selection
      }))
    })

    this.element.remove()
  }
}
